import { CrudStoreItem } from 'legacy/lut/classes/models/CrudStoreItem'

import { CrudStore } from 'core/types/crudStore'

export async function getTopPartnerId(partnerId: string = '') {
  const source =
    partnerId.indexOf('new-') === -1 ? CrudStoreItem.PartnerAllData : CrudStoreItem.NewPartners

  const crud = CrudStore.get(source, `useTopPartnerId-${partnerId}`)

  const topPartnerId = await crud
    .getById({ id: partnerId, keyField: 'PartnerID' })
    .then(({ TopPartnerID }) => {
      return TopPartnerID
    })
    .catch(() => partnerId)

  return topPartnerId || partnerId
}
